export default __webpack_public_path__ + "static/media/avatar4.2e6a4768.jpg";